import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

/* Replacement for react-day-picker v9's default <select>-based caption
 * dropdowns. The native selects render the browser's chrome for their open
 * list, which looks terrible on Windows and doesn't match our theme — so we
 * swap in a Bootstrap dropdown via <DayPicker components={{ Dropdown }}>.
 *
 * v9 hands us `{ value, options, onChange, 'aria-label', className }`; we
 * call `onChange` with a React-event shape (`{ target: { value } }`) so the
 * library's internal handler — which reads `e.target.value` — still works.
 */
export default function CalendarDropdown({
    value,
    options,
    onChange,
    'aria-label': ariaLabel,
    className,
}) {
    const current = options?.find(o => String(o.value) === String(value));

    return (
        <UncontrolledDropdown className={className}>
            <DropdownToggle
                caret
                color="light"
                size="sm"
                className="dp-cal-dropdown-toggle"
                aria-label={ariaLabel}
            >
                {current?.label ?? value}
            </DropdownToggle>
            <DropdownMenu className="dp-cal-dropdown-menu">
                {options?.map(o => (
                    <DropdownItem
                        key={o.value}
                        active={String(o.value) === String(value)}
                        disabled={o.disabled}
                        onClick={() => onChange?.({ target: { value: o.value } })}
                    >
                        {o.label}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </UncontrolledDropdown>
    );
}
